export const routes = {
  index: '/',
  tokenLogin: '/token-login',
  dataManagement: {
    organization: (id: string) => `/data-management/organizations/${id}/featured-wla-programs`,
  },
};
